<template>
  <div class="employees-leaves-old-layout" :class="{ 'employees-leaves-old-layout--schedule': isSchedule }">
    <app-cells position="between" :margin-bottom="12">
      <h1 class="title">Leave (Sales)</h1>
    </app-cells>
    <app-tabs design="new" refined :tabs="tabsToShow" />
    <div class="employees-leaves-old-layout__content">
      <transition name="fade" mode="out-in">
        <router-view :key="$route.name" ui-version="new" />
      </transition>
    </div>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'EmployeesLeavesOldLayout',
  components: { AppTabs },
  computed: {
    isSchedule() {
      return this.$route.name === 'employees-sales-leaves-schedule'
    },
    tabsToShow() {
      const roles = ['general_manager', 'sales_supervisor', 'marketing_supervisor']
      if (!roles.some(role => this.$store.state.userGroups.some(userRole => userRole.code === role))) return []
      return [
        { name: 'employees-sales-leaves', label: 'Requests', roles },
        { name: 'employees-sales-leaves-schedule', label: 'Schedule', roles },
        { name: 'employees-sales-leaves-list', label: 'Leaves', roles },
      ]
    },
  },
}
</script>

<style lang="sass" scoped>
.employees-leaves-old-layout--schedule
  display: grid
  grid-template-rows: auto auto minmax(0, 1fr)
  height: calc(100vh - 70px)
  overflow: hidden

  +max-w($desktop_sm)
    height: calc(100vh - 50px)

  .employees-leaves-old-layout__content
    min-height: 0
    overflow: hidden
</style>
